/*
 * Registro de componentes de la landing (carruseles, animaciones, acordeones, contadores).
 * Cada componente se registra con init(el) / destroy(el); este archivo los (re)inicializa
 * al cargar y ante los eventos del editor de Shopify, sin depender del orden de secciones.
 */
(function () {
  if (window.EBL) return;
  var registro = {};

  function initEn(scope) {
    Object.keys(registro).forEach(function (nombre) {
      scope.querySelectorAll('[data-ebl-component="' + nombre + '"]').forEach(function (el) {
        if (el.__eblInit) return;
        el.__eblInit = true;
        registro[nombre].init(el);
      });
    });
  }
  function destroyEn(scope) {
    Object.keys(registro).forEach(function (nombre) {
      scope.querySelectorAll('[data-ebl-component="' + nombre + '"]').forEach(function (el) {
        if (!el.__eblInit) return;
        if (registro[nombre].destroy) registro[nombre].destroy(el);
        el.__eblInit = false;
      });
    });
  }

  window.EBL = {
    registrar: function (nombre, impl) { registro[nombre] = impl; initEn(document); },
    initEn: initEn,
    destroyEn: destroyEn
  };

  document.addEventListener('DOMContentLoaded', function () { initEn(document); });
  document.addEventListener('shopify:section:load', function (e) { initEn(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyEn(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { destroyEn(e.target); initEn(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest('[data-ebl-component]');
    if (el && registro[el.dataset.eblComponent] && registro[el.dataset.eblComponent].select) {
      registro[el.dataset.eblComponent].select(el, e.target);
    }
  });
})();
